import React from 'react';
import { useParams } from 'react-router-dom';
import { SpeechStream } from '@twigeducation/speechstream';
import PropTypes from 'prop-types';
import AssetGlossaryPage from './AssetGlossaryPage';
import AssetPage from './AssetPage';

const SpeechStreamWithStartingPoints = props => {
    const { language } = props;
    const languageCode = language || 'en-US';

    return (
        <SpeechStream
            {...props}
            languageCode={languageCode}
            startingPoints={['termModalBody']}
            autoPlay
            showFixedToolbar
            fillColor="#0D729A"
        />
    );
};

SpeechStreamWithStartingPoints.propTypes = {
    sessionId: PropTypes.string,
    language: PropTypes.string,
};

SpeechStreamWithStartingPoints.defaultProps = {
    sessionId: undefined,
    language: 'en-US',
};

const AssetPageRedirect = props => {
    const { type } = useParams();
    if (type === 'glossary-term') return <AssetGlossaryPage {...props} SpeechStream={SpeechStreamWithStartingPoints} />;
    return <AssetPage {...props} />;
};

export default AssetPageRedirect;
